import { FC } from "react";

import { MappedAllAssessmentTableRow } from "../utils";

import { t } from "i18n/i18n";
import { Chip } from "mds/components/Chip";
import { Tooltip } from "mds/components/Tooltip";

interface SubmissionsCellProps {
  row: MappedAllAssessmentTableRow;
}

export const SubmissionsCell: FC<SubmissionsCellProps> = ({ row }) => {
  const isAssessed = !row.isMarkedComplete;
  const hasUnassessedLateCount = isAssessed && row.unassessedLateSubmissionsCount > 0;
  const hasUnseenLateCount = isAssessed && row.unseenSubmissionsCount > 0;

  const chip = hasUnassessedLateCount ? (
    <Tooltip
      text={t("assessment_dashboard.all.late_count_tooltip", {
        count: row.unassessedLateSubmissionsCount,
      })}
    >
      <Chip kind="orange" size="xs">
        {t("assessment_dashboard.all.late_count", { count: row.unassessedLateSubmissionsCount })}
      </Chip>
    </Tooltip>
  ) : hasUnseenLateCount ? (
    <Tooltip
      text={t("assessment_dashboard.all.new_count_tooltip", {
        count: row.unseenSubmissionsCount,
      })}
    >
      <Chip kind="blue" size="xs">
        {t("assessment_dashboard.all.new_count", { count: row.unseenSubmissionsCount })}
      </Chip>
    </Tooltip>
  ) : null;

  return (
    <div className="flex items-center gap-2">
      <span>{row.totalSubmissionsCount || "-"}</span>
      {chip}
    </div>
  );
};
